import React from 'react';

// Sección editorial importada de WordPress (Elementor). Replica el acomodo
// original: 1 columna, o 2 columnas (izquierda = frase grande en serif,
// derecha = texto/foto), con foto de fondo opcional (texto encima).
//
// data = {
//   columns: [[item, ...], [item, ...]],
//   background: { image, mobileImage } | null,
//   full: true   // imagen sola a todo lo ancho
// }
// item = heading{text, role: 'statement'|'subhead'} | eyebrow{text} |
//        paragraph{text} | html{html} | image{src, alt} | video{src}
//
// `html` viene saneado desde el importador (solo p, br, strong, em, listas y
// links), por eso se inserta tal cual.

function Item({ item }) {
  switch (item.type) {
    case 'eyebrow':
      return <p className="wp-eyebrow">{item.text}</p>;
    case 'heading':
      return item.role === 'statement'
        ? <h2 className="wp-statement">{item.text}</h2>
        : <h3 className="wp-subhead">{item.text}</h3>;
    case 'paragraph':
      return <p className="wp-paragraph">{item.text}</p>;
    case 'html':
      return <div className="wp-html" dangerouslySetInnerHTML={{ __html: item.html }} />;
    case 'image':
      return <img className="wp-image" src={item.src} alt={item.alt || ''} loading="lazy" />;
    case 'video':
      return (
        <video
          className="wp-video"
          src={item.src}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
        />
      );
    default:
      return null;
  }
}

export default function BlogWpSection({ data }) {
  const { columns = [], background, full } = data || {};
  const filled = columns.filter((c) => c && c.length);
  if (!filled.length) return null;

  if (full) {
    return (
      <div className="wp-section wp-section--full">
        {filled[0].map((item, i) => <Item key={i} item={item} />)}
      </div>
    );
  }

  const twoCols = columns.length >= 2;
  const className = [
    'wp-section',
    twoCols ? 'wp-section--split' : 'wp-section--single',
    background ? 'wp-section--bg' : '',
  ].join(' ');

  return (
    <section className={className}>
      {background && (
        <picture className="wp-section-bg">
          {background.mobileImage && (
            <source media="(max-width: 767px)" srcSet={background.mobileImage} />
          )}
          <img src={background.image} alt="" loading="lazy" />
        </picture>
      )}
      <div className="wp-section-inner">
        {(twoCols ? columns.slice(0, 2) : [filled[0]]).map((col, ci) => (
          <div key={ci} className={`wp-col wp-col--${ci === 0 && twoCols ? 'left' : 'right'}`}>
            {(col || []).map((item, i) => <Item key={i} item={item} />)}
          </div>
        ))}
      </div>
    </section>
  );
}
